/**
 * Tail of /api/chat-stream: the server can finish (HTTP 200, [DONE] logged)
 * while reader.read() throws before the client parses [DONE].
 * A tool call blocks a blind retry. It must not discard text that already arrived.
 */

export const CHAT_STREAM_REPLY_KEPT_TOAST = {
  title: 'Reply kept',
  description:
    'The connection closed before the turn finished saving. The text above is what arrived.',
} as const

export type ChatStreamTailRecovery = 'keep' | 'retry' | 'banner'

export function assistantTextWorthKeeping(
  assistantMessage: string,
  segmentStart: number,
  narrationPlaceholderOnly: boolean,
): string {
  const raw = narrationPlaceholderOnly
    ? assistantMessage.slice(0, Math.max(0, segmentStart))
    : assistantMessage
  return raw.trim()
}

export function decideChatStreamTailRecovery(input: {
  recoverableText: string
  streamRetryAttempt: number
  userAborted: boolean
  stalled: boolean
  sawToolCallEvent: boolean
  proposedEditCount: number
  touchedFileCount: number
}): ChatStreamTailRecovery {
  if (input.recoverableText.trim()) return 'keep'

  const safeToRetry =
    input.streamRetryAttempt === 0 &&
    (!input.userAborted || input.stalled) &&
    !input.sawToolCallEvent &&
    input.proposedEditCount === 0 &&
    input.touchedFileCount === 0

  return safeToRetry ? 'retry' : 'banner'
}
